import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";

import Header from "./CommonPage/Headers/Header";
import Footer from "./CommonPage/Footers/Footer";

import Banner from "./Componenets/BannerPage/Banner";
import { Discover } from "./Componenets/Discovers/Discover";
import GlobalAssets from "./Componenets/Globalassets/GlobalAssets";
import GlobalStage from "./Componenets/Globalassets/GlobalStage";
import Wealth from "./Componenets/Globalassets/Wealth";
import Ourinvest from "./Componenets/OurInvester/Ourinvest";
import { WhatsappTradings } from "./Componenets/WhatsAppTrading/WhatsappTradings";
import Account from "./Componenets/AccountType/Account";
import LandingPages from "./Pages/LandingPage/LandingPages";
import { TradingPage } from "./Pages/TradingPage/TradingPage";
import { StockDerivatives } from "./Pages/TradingPage/StockDerivatives";
import { Commonditity } from "./Pages/TradingPage/Commonditity";
import SubHeader from "./CommonPage/SubHeader/SubHeader";

import { Metals } from "./Pages/TradingPage/Metals";
import { Shares } from "./Pages/TradingPage/Shares";
import ScrollToTop from "./Componenets/ScrollToTop";
import { NewCrypto } from "./Pages/TradingPage/NewCrypto";
import { EquityNew } from "./Pages/TradingPage/EquityNew";
import { Energies } from "./Pages/TradingPage/Energies";
import Login from "./Layouts/LoginLayout/Login";
import LegalDocuments from "./Pages/Legal/LegalDocuments";
import Need from "./Componenets/NeedComponent/Need";
import HelpSupportMain from "./Componenets/help-support-section/help-support-main/HelpSupportMain";
import OurContact from "./Pages/Countactpage/OurContact";
import Cookies2 from "./CommonPage/Cookies2/Cookies2";
import Regulations from "./Pages/Legal/Regulations";
import PartnerWithUs from "./Componenets/PartnerPage/PartnerWithUs";
import MT5 from "./Pages/MT5/MT5"
import WhyBBCorp from "./Pages/WhyBBCorp/WhyBBCorp";

const Loginlayout = () => {
  return <Login />;
};

// 🧠 This inner component handles the layout logic
const LayoutWrapper = () => {
  const location = useLocation();
  const hideHeaderFooter = location.pathname === "/login";

  return (
    <>
      {!hideHeaderFooter && <Header />}
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<LandingPages />} />
        <Route path="/login" element={<Loginlayout />} />
        <Route path="/banner" element={<Banner />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/global-assets" element={<GlobalAssets />} />
        <Route path="/global-stage" element={<GlobalStage />} />
        <Route path="/wealth" element={<Wealth />} />
        <Route path="/our-investors" element={<Ourinvest />} />
        <Route path="/whatsapp-trading" element={<WhatsappTradings />} />
        <Route path="/account" element={<Account />} />
        <Route path="/forex-trading" element={<TradingPage />} />
        <Route path="/stock-derivatives" element={<StockDerivatives />} />
        <Route path="/commodities" element={<Commonditity />} />
        <Route path="/precious-metals" element={<Metals />} />
        <Route path="/shares" element={<Shares />} />
        <Route path="/cryptocurrencies" element={<NewCrypto />} />
        <Route path="/equity" element={<EquityNew />} />
        <Route path="/energies" element={<Energies />} />
        <Route path="/legal" element={<LegalDocuments />} />
        <Route path="/regulations" element={<Regulations />} />
        <Route path="/contact" element={<OurContact />} />
        <Route path="/cookies" element={<Cookies2 />} />
        <Route path="/help" element={<Need />} />
        <Route path="/partner" element={<PartnerWithUs />} />
        <Route path="/help/help-support" element={<HelpSupportMain />} />
        <Route path="/mt5" element={<MT5 />} />
        <Route path="/who-bbcorp" element={<WhyBBCorp />} />
      </Routes>

      {!hideHeaderFooter && <Footer />}
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <Router>
        <LayoutWrapper />
      </Router>
    </LanguageProvider>
  );
}

export default App;
